import { render, staticRenderFns } from "./columnTitle.vue?vue&type=template&id=0cf865af&scoped=true"
import script from "./columnTitle.vue?vue&type=script&lang=js"
export * from "./columnTitle.vue?vue&type=script&lang=js"
import style0 from "./columnTitle.vue?vue&type=style&index=0&id=0cf865af&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf865af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\01_Projects\\zr_code\\exam_registration_api\\exam-registration-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cf865af')) {
      api.createRecord('0cf865af', component.options)
    } else {
      api.reload('0cf865af', component.options)
    }
    module.hot.accept("./columnTitle.vue?vue&type=template&id=0cf865af&scoped=true", function () {
      api.rerender('0cf865af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/columnTitle.vue"
export default component.exports